import { FuseUtils } from '../../../../../core/fuseUtils';

export class Order {
    id: string;
    reference: string;
    subtotal: string;
    tax: string;
    discount: string;
    total: string;
    date: string;
    phone: any;
    customer: any;
    products: any[];
    status: any[];
    payment: any;
    shippingDetails: any[];
    payment_method_title: string;
  
    constructor(order?) {
        order = order || {};
        this.id = order.id || FuseUtils.generateGUID();
        this.reference = order.transaction_id || FuseUtils.generateGUID();
        this.subtotal = order.subtotal || 0;
        this.tax = order.tax || 0;
        this.discount = order.discount || 0;
        this.total = order.total || 0;
        this.date = order.date_created || '';
        this.customer = order.billing || {};
        this.products = order.line_items || [];
        this.status = order.status || [];
        this.payment = order.billing || {};
        this.shippingDetails = order.shipping || [];
        this.payment_method_title = order.payment_method_title || '';
        
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/order/order.model.ts